<template>
  <SideBar />
  <main>
    <HeaderApp />
    <InitAuthentification>
      <RouterView />
    </InitAuthentification>
    <FooterApp />
  </main>
  <AppRegisterGlobals />
  <div
    v-if="showEnv()"
    class="envBox"
  >
    <BasicText
      weight="semibold"
      :label="currentEnv"
      color="red"
    />
  </div>
</template>

<script setup lang="ts">
  import HeaderApp from '@/features/interface/layout/header/HeaderApp.vue'
  import SideBar from '@/features/interface/layout/sideBar/SideBar.vue'
  import FooterApp from './features/interface/layout/footer/FooterApp.vue'
  import InitAuthentification from '@/features/auth/authentification/components/InitAuthentification.vue'
  import AppRegisterGlobals from './AppRegisterGlobals.vue'
  import type { Environnements } from './features/application/shared/Environnements.types'

  const currentEnv = import.meta.env.VITE_ENV as Environnements

  const showEnv = () => {
    return currentEnv === 'dev' || currentEnv === 'staging' || currentEnv === 'rec01' || currentEnv === 'rec02'
  }
</script>

<style scoped lang="less">
  @import '/src/assets/Mont/Mont.less';

  .envBox {
    right: 10px;
    bottom: 10px;
    position: absolute;
    padding: 12px;
    border: solid 2px red;
    border-radius: 8px;
  }

  main {
    container-type: inline-size;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: hidden;
    position: sticky;
    top: 0;
  }
</style>
